/**
 * Add Member Modal — built on TradeForm.
 *
 * Expects the modal HTML to already exist in the DOM (rendered by
 * snippets/add-member-modal.liquid via trade-modal.liquid).
 *
 * Two states: form (default) and success. TradeForm manages state
 * toggling via the successState config. Dispatches
 * 'trade:member-invited' when closing from success state.
 *
 * Exposes:
 *   window.TradeAddMemberModal.open()
 *   window.TradeAddMemberModal.close()
 */
(function () {
	const overlay = document.getElementById('add-member-modal');
	if (!overlay) return;

	/* ── TradeForm config ── */

	const form = createTradeForm({
		overlay: overlay,
		fields: {
			email: {
				id: 'member-email-input',
				required: 'Please enter an email address.',
				validate: function (value) {
					if (value.indexOf('@') === -1) return 'Please enter a valid email address.';
				},
			},
		},
		submitBtn: 'send-invite-btn',
		errorContainer: 'add-member-error-message',
		errorText: 'add-member-error-text',
		resetBtnText: 'Send Invite',
		successState: true,
		successCloseBtn: 'close-add-member-success-btn',
		triggerSelector: '[data-open-add-member]',
		focusOnOpen: 'email',
		submit: {
			url: window.tradeApiBase + '/users/invite',
			source: 'TradeAddMemberModal.sendInvite',
			method: 'POST',
			loadingText: 'Sending...',
			buildPayload: function (values) { return { targetEmail: values.email }; },
			onSuccess: function (data, ctrl) {
				ctrl.showSuccessState();
			},
			onError: function (err, ctrl) {
				console.error('Error sending invite:', err);
				ctrl.showError('Failed to send invitation. Please try again.');
			},
		},
		onClose: function (ctrl) {
			if (ctrl.currentState === 'success') {
				document.dispatchEvent(new CustomEvent('trade:member-invited'));
			}
		},
	});

	/* ── public API ── */

	window.TradeAddMemberModal = {
		open: function () { form.modal.open(); },
		close: function () { form.modal.close(); },
	};
})();
